/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
'use strict';
module.exports = {
    PRICE_RANGE: {
        type: 'accommodationFilterByPrice',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['PRICE_RANGE']),
    },
    GUEST_REVIEWS: {
        type: 'accommodationFilterByReview',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['GUEST_REVIEWS']),
    },
    DISTANCE_CENTER: {
        type: 'accommodationFilterByDistance',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['DISTANCE_CENTER']),
    },
    HOTEL_NAME: {
        type: 'accommodationFilterByName',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['HOTEL_NAME']),
    },
    OUR_SELECTION: {
        type: 'accommodationFilterByOurSelection',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['OUR_SELECTION']),
    },
    NEIGHBOURHOOD: {
        type: 'accommodationFilterByNeighbourhood',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['NEIGHBOURHOOD']),
    },
    BOARD_TYPE: {
        type: 'accommodationFilterByBoardType',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['BOARD_TYPE']),
    },
    GUEST_RATING: {
        type: 'accommodationFilterByCategory',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['GUEST_RATING']),
    },
    AC: {
        type: 'accommodationFilterByCustomFacilityGroups',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['AC']),
    },
    BAR_RESTAURANT: {
        type: 'accommodationFilterByCustomFacilityGroups',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['BAR_RESTAURANT']),
    },
    LIFT: {
        type: 'accommodationFilterByCustomFacilityGroups',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['LIFT']),
    },
    FREE_AIRPORT_SHUTTLE: {
        type: 'accommodationFilterByCustomFacilityGroups',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['FREE_AIRPORT_SHUTTLE']),
    },
    FREE_PARKING: {
        type: 'accommodationFilterByCustomFacilityGroups',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['FREE_PARKING']),
    },
    FREE_WIFI: {
        type: 'accommodationFilterByCustomFacilityGroups',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['FREE_WIFI']),
    },
    GYM: {
        type: 'accommodationFilterByCustomFacilityGroups',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['GYM']),
    },
    HANDICAPPED: {
        type: 'accommodationFilterByCustomFacilityGroups',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['HANDICAPPED']),
    },
    HEATING: {
        type: 'accommodationFilterByCustomFacilityGroups',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['HEATING']),
    },
    PETS_ALLOWED: {
        type: 'accommodationFilterByCustomFacilityGroups',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['PETS_ALLOWED']),
    },
    ROOM_SERVICE: {
        type: 'accommodationFilterByCustomFacilityGroups',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['ROOM_SERVICE']),
    },
    SPA_SAUNA: {
        type: 'accommodationFilterByCustomFacilityGroups',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['SPA_SAUNA']),
    },
    SWIMMING_POOL: {
        type: 'accommodationFilterByCustomFacilityGroups',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['SWIMMING_POOL']),
    },
    APARTAMENT: {
        type: 'accommodationFilterByType',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['APARTAMENT']),
    },
    GUEST_HOUSE: {
        type: 'accommodationFilterByType',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['GUEST_HOUSE']),
    },
    HOSTEL: {
        type: 'accommodationFilterByType',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['HOSTEL']),
    },
    BED_AND_BREAKFAST: {
        type: 'accommodationFilterByType',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['BED_AND_BREAKFAST']),
    },
    HOTEL: {
        type: 'accommodationFilterByType',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['HOTEL']),
    },
    MOTEL: {
        type: 'accommodationFilterByType',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['MOTEL']),
    },
    RESIDENCE: {
        type: 'accommodationFilterByType',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['RESIDENCE']),
    },
    RESORT: {
        type: 'accommodationFilterByType',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['RESORT']),
    },
    RYOKAN: {
        type: 'accommodationFilterByType',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['RYOKAN']),
    },
    UNKNOWN: {
        type: 'accommodationFilterByType',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['UNKNOWN']),
    },
    CANCELLATION_FREE: {
        type: 'accommodationFilterByReservationPolicies',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['CANCELLATION_FREE']),
    },
    PAY_LATER: {
        type: 'accommodationFilterByReservationPolicies',
        label: Odigeo.Utils.capitalize(Odigeo.UIElements.translations.dynpackProduct.filterTags['PAY_LATER']),
    },
};
